import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import * as conversation from '@alme/ui-web/ref/lib-alme-request';
import { setupComponents } from './setup-components';
import { setupReducers } from './setup-reducers';
import { setupState } from './setup-state';
import setupGlobalLaunch from '../components/setupGlobalLaunch';
import { overrideFunctions } from './overrides';

export default class AlmeWebClient {
    constructor(settings, onContactUsPage = false) {
        this._onContactUsPage = onContactUsPage;
        const components = setupComponents(conversation, this._onContactUsPage);
        this._components = components.components;
        this._initialization = components.initialization;
        overrideFunctions(settings, this._components);
    }

    initialize() {
        const middlewares = [];
        middlewares.push(thunk);

        // set up redux extension
        const composeEnhancers = composeWithDevTools({
            maxAge: 500,
            actionsBlacklist: [
                'PERSIST_STATE_CHANGE',
                'REFRESH_PERSISTED_STATE',
                'SET_INACTIVITY_TIME',
                'UPDATE_CURRENT_INPUT',
            ],
        });
        this._store = createStore(setupReducers(this._components, this._initialization), setupState(this._components),
            composeEnhancers(applyMiddleware(...middlewares)));

        const initializePromises = this._initialization.initialize(this._store);

        Object.keys(this._components).forEach((comp) => {
            if (comp !== 'initialization' && comp !== 'ttsResponseHandler') {
                if (this._components[comp].initialize) {
                    this._components[comp].initialize(this._store, initializePromises);
                }
            } else if (comp === 'initialization') {
                const initPromise = this._components.initialization.initialize(this._store);
                initPromise.then(() => {
                    this._components.ttsResponseHandler.initialize(this._store);
                    this._components.ttsResponseHandler.handleInitialize(this._store);

                    if (this._onContactUsPage) {
                        // Dispatch restore action
                        this._store.dispatch({
                            type: "RESTORE_ALME_WINDOW",
                            payload: {
                                stateLocation: "IsMinimized",
                                params: { LaunchType: "Relaunch" },
                            },
                        });
                    }
                });

            }
        });

        this._components.ivaAvailability.PerformAvailCheck(initializePromises.onLoad);
        conversation.setStore(this._store);
        setupGlobalLaunch();
    }

    start(){
        this._initialization.startApplicationInitialize();
    }
}



// WEBPACK FOOTER //
// ./src/client.js